import { NgIf } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, IconComponent } from '@sc/ui-components';
import { ActionDialogType } from '../../types';

@Component({
  selector: 'sc-action-dialog',
  styleUrls: ['./action-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatDialogModule,
    IconComponent,
    NgIf,
    ButtonComponent,
    TranslateModule,
  ],
  template: `
    <div class="dialog_container">
      <button mat-dialog-close="CANCEL">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate: { dialogTitle: data.title }
        }}</span>
      </button>
      <div class="dialog_header">
        <sc-icon *ngIf="data.iconName" [name]="data.iconName"></sc-icon>
        <span *ngIf="data.emoji" aria-hidden="true"> {{ data.emoji }} </span>
      </div>
      <div class="dialog_title">
        <h1 class="sc-design-title-h2" id="action-title-id">
          {{ data.title }}
        </h1>
      </div>
      <div class="dialog_body sc-design-text-3">
        <p [innerHTML]="data.text"></p>
      </div>
      <sc-button
        mat-dialog-close="VALIDATE"
        [title]="
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate: { dialogTitle: data.title }
        "
        >{{ data.buttonText }}</sc-button
      >
    </div>
  `,
})
export class ActionDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActionDialogType,
    public dialogRef: MatDialogRef<ActionDialogComponent>
  ) {}
}
